<template>
<div class="font-sans antialiased bg-white fixed w-full" style="z-index: 999" id="app">
    <nav class="flex items-center justify-between flex-wrap p-4">
        <div class="flex items-center flex-no-shrink  mr-6">
            <router-link to="/">
                <div class="tenant-logo flex items-center text-black mr-6">
                    <img class="object-cover" width="70" height="70" src="https://edclearn-images.nyc3.cdn.digitaloceanspaces.com/logos/new-logo.png" alt="" />
                </div>
            </router-link>
        </div>
        <div class="block md:hidden">
            <button @click="toggle" class="flex items-center px-3 py-2 border rounded text-teal-lighter border-teal-light hover  hover:border-white">
                <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <title>Menu</title>
                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                </svg>
            </button>
        </div>
        <div :class="open ? 'block' : 'hidden'" class="w-full flex-grow md:flex md:items-center md:w-auto">
            <div class="text-sm md:flex-grow"></div>
            <div class="nav-list">
                <p class="block mt-4 md:inline-block  md:px-4  md:mt-0 mr-4" style="cursor: pointer" @click="$router.push({ name: 'Home' })">
                    Home
                </p>
                <!--<router-link to="/courses">
                    <p style="cursor: pointer" class="block mt-4 md:inline-block  md:px-4  md:mt-0 mr-4">
                        Courses
                    </p>
                </router-link>-->

                <a href="#about">
                    <p class="block mt-4 md:inline-block  md:px-4  md:mt-0 mr-4">
                        About Us
                    </p>
                </a>

                <a href="#contact">
                    <p class="block mt-4 md:inline-block  md:px-4  md:mt-0 mr-4">
                        Contact Us
                    </p>
                </a>

                <p class="block mt-4 md:inline-block  md:px-4  md:mt-0 " @click="$router.push({ name: 'external-wishlist' })">
                    <i class="text-lg cursor-pointer nav-color fas fa-heart"></i>
                </p>

                <p class="block mt-4 md:inline-block  md:px-4  md:mt-0 relative" @click="$router.push({ name: 'external-cart' })">
                    <span class="cart-count mr-0 h-2 w-2 absolute flex items-center justify-center bg-white border font-bold shadow-xl p-2" style="border-radius: 50%; top: -10px; left: 11px; font-size: 8px;">
                        {{ courseCart.length }}
                    </span>
                    <i class="text-lg  mx-2 cursor-pointer nav-color fas fa-cart-plus"></i>
                </p>

                <lbutton v-if="learnerRegistration" @click="$router.push('/learner/register')" class="rounded-lg shadow-lg gradient-button text-white block mt-4 md:inline-block  md:px-4  md:mt-0 mr-4" textColor="#fff">Sign Up</lbutton>

                <lbutton @click="$router.push('/tenant/login')" class="rounded-lg shadow-lg gradient-button text-white block mt-4 md:inline-block  md:px-4  md:mt-0 mr-4" textColor="#fff">Login</lbutton>
            </div>
        </div>
    </nav>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import SettingsMixin from "@/mixins/SettingsMixin";
export default {
    mixins: [SettingsMixin],
    components: {
        lbutton: () => import("@/components/general/button"),
    },
    data() {
        return {
            open: false,
            courseCart: [],
        };
    },
    methods: {
        toggle() {
            this.open = !this.open;
        },
    },
    async mounted() {
        let temp = localStorage.getItem("lms_cart");
        if (temp) {
            this.courseCart = JSON.parse(temp);
        }
    },
    computed: {
        ...mapGetters(["getThemeColor"]),
    },
    created() {
        this.$Bus.$on("cartUpdated", (data) => {
            this.courseCart = data;
        });

        document.documentElement.style.setProperty(
            "--lms-tenant",
            `${this.getThemeColor}`
        );
    },
};
</script>

<style lang="scss" scoped>
.tenant-logo {
    // height: 40px;
    width: 140px;

    img {
        height: 100%;
        width: 100%;
    }
}

div {
    color: color(lms-tenant);
}

.tenant-main-color {
    color: color(lms-tenant);
}

.gradient-button {
    color: color(lms-tenant);
}

.nav-list {
    p {
        color: color(lms-tenant) !important;
    }
}
</style>
